import React from 'react';

import { datadogRum } from '@datadog/browser-rum';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

import { itemByLanguage } from '@/utils/language';

import ConfirmationModal from '@/components/popups/ConfirmationModal';
import ToastMessageBlock from '@/components/Toasts/SuccessToast';

import { deletePlan, Plan } from '@/_generated/api-clients/xp';

interface DeletePlanProps {
  plan: Plan;
  refetchPlans: () => void;
  setShowDeletePlan: (show: boolean) => void;
  showDeletePlan: boolean;
}

const DeletePlan: React.FC<DeletePlanProps> = ({
  plan,
  refetchPlans,
  setShowDeletePlan,
  showDeletePlan,
}) => {
  const { t } = useTranslation();
  const onDeletePlan = () => {
    const planId = plan.id;

    deletePlan({ path: { planId } })
      .then(() => {
        refetchPlans();
        toast.custom(toastObj => (
          <ToastMessageBlock id={toastObj.id}>
            {`${itemByLanguage(plan.name, '')} ${t('TrainingPlans.toastMessage.deleted')}`}
          </ToastMessageBlock>
        ));
      })
      .catch((err: unknown) => {
        datadogRum.addError(
          err instanceof Error ? err : new Error(String(err)),
        );
      });
  };

  return (
    <ConfirmationModal
      bodyText={t('Generic.deleteObject', {
        name: itemByLanguage(plan.name),
        object: t('Generic.plan').toLowerCase(),
      })}
      headerText={t('Generic.deleteHeader', {
        type: t('Generic.plan'),
      })}
      isOpen={showDeletePlan}
      onClose={() => setShowDeletePlan(false)}
      primaryButtonHandler={() => {
        onDeletePlan();
        setShowDeletePlan(false);
      }}
      primaryButtonText={t('Button.delete')}
      primaryButtonVariant="destructive"
      secondaryButtonHandler={() => setShowDeletePlan(false)}
      secondaryButtonText={t('Button.cancel')}
    />
  );
};
export default DeletePlan;
